/**
 * Qué clientes ofrece la pantalla de Informes, en un solo lugar.
 *
 * El payload de `node-to-gsheet/sync-configuration/form-data` trae `{id, name, is_active}`
 * (backend: `node_to_gsheet/views.py`) y **no** viene filtrado por activo — sólo por borrado
 * lógico. La asignación de usuario SÍ la resuelve el backend (`request.user.clients()` para los
 * no-admin), así que acá no se replica: la única condición que falta es la de activo, igual que
 * hace el Explorador (`DataExplorerHeader.js`, `.filter(c => c.is_active)`).
 *
 * Hasta el 07/09 los tres call sites de Informes filtraban por `c.active !== false`, que es el
 * shape de OTRO presenter (`presenters/agency_clients.py`, endpoints `/agent/*`). Acá ese campo no
 * existe, `undefined !== false` es `true` y el filtro no filtraba nada: el selector ofrecía 67
 * clientes de los que el render autorizaba 29, y el default (`agencyClients[0]`, sin filtrar) caía
 * en un inactivo — la pantalla abría en «No se pudo calcular el informe» sin que nadie tocara nada.
 *
 * El NOMBRE del cliente actual se resuelve aparte y sobre la lista COMPLETA: un informe guardado
 * sobre un cliente que después se desactivó tiene que seguir mostrando su nombre; lo que se filtra
 * son las OPCIONES que se ofrecen.
 */

export function selectableClients(agencyClients) {
    return (agencyClients || []).filter((c) => !!c.is_active);
}

export function defaultClientId(agencyClients, clientFromUrl) {
    if (clientFromUrl) return String(clientFromUrl);
    const first = selectableClients(agencyClients)[0];
    return first ? String(first.id) : null;
}

export function clientNameOf(agencyClients, clientId) {
    const found = (agencyClients || []).find((c) => String(c.id) === String(clientId));
    return found ? found.name : '';
}
